// native
import { NgModule } from "@angular/core";

// module
import { SharedModule } from "../shared/shared.module";

// component
import { UnityComponent } from "./unity.component";

@NgModule({
  imports: [
    SharedModule
  ],
  declarations: [
    UnityComponent
  ]
})
export class UnityModule { }